var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-attr-filter"},[_c('rp-attr-filter-header',{attrs:{"item":_vm.roleDatasource,"ds-length":_vm.dsLength}}),_c('rp-attr-filter-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }